import { render } from "./setOrganizationprovider.vue?vue&type=template&id=24b9300f&scoped=true"
import script from "./setOrganizationprovider.vue?vue&type=script&lang=js"
export * from "./setOrganizationprovider.vue?vue&type=script&lang=js"

import "./setOrganizationprovider.vue?vue&type=style&index=0&id=24b9300f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b9300f"]])

export default __exports__